export default {
  bind(el, binding) {
    let isUpdating = false; // Флаг для предотвращения рекурсии

    const formatNumberValue = (inputValue) => {
      if (!inputValue) return inputValue;

      let value = inputValue.replace(/[^\d.,]/g, '');
      value = value.replace(/,/g, '.');
      const parts = value.split('.');

      value = parts.length > 2 ? `${parts[0]}.${parts.slice(1).join('')}` : value;
      if (value.startsWith('.')) value = `0.${value}`;

      return value;
    };

    const formatOrdinaryNumberValue = (inputValue) => {
      if (!inputValue) return inputValue;

      const value = inputValue.replace(/[^\d]/g, '');

      return value;
    };

    const formatTextValue = (inputValue) => {
      if (!inputValue) return inputValue;

      const value = inputValue.replace(/./g, '');

      return value;
    };

    const handleEvent = (e) => {
      if (isUpdating) return;
      let value;

      switch (binding.value) {
        case 'number':
          value = formatNumberValue(e.target.value);
          break;
        case 'ordinaryNumber':
          value = formatOrdinaryNumberValue(e.target.value);
          break;
        case 'text':
          value = formatTextValue(e.target.value);
          break;
        default:
          break;
      }

      isUpdating = true;
      e.target.value = value;

      e.target.dispatchEvent(new Event('input', { bubbles: true }));
      isUpdating = false;
    };

    // Добавляем обработчики событий
    el.addEventListener('input', handleEvent);
    el.addEventListener('blur', handleEvent);
    el.addEventListener('focus', handleEvent);
  },
};
